import './Navbar.scss';
import { useToggle, useWindowSize } from '../../helpers/functions/hooks';
import { useEffect, useRef, useState } from 'react';
import Spacer from '../Spacer';
import RenderIf from '../RenderIf';
import MobileDropdownMenu from '../MobileDropdownMenu';
import { MotionValue, motion, useMotionValueEvent, useTransform } from 'framer-motion';
import { scrollToSection } from '../../helpers/functions';
import DropdownMenu from '../DropdownMenu';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { weatherAPI } from '../../helpers/constants';

export type NavbarProps = { scrollYProgress: MotionValue<number> };
const Navbar = ({ scrollYProgress }: NavbarProps): JSX.Element => {
    const [isActive, toggle] = useToggle();
    const [temperature, setTemperature] = useState<number>();
    const [weatherIcon, setIcon] = useState<string>('00');
    const [weatherConditions, setWeatherConditions] = useState<string>('');
    const [time, setTime] = useState<string>('00:00 PM');
    const { width } = useWindowSize();
    const { pathname } = useLocation();
    const nameRef = useRef<HTMLHeadingElement>(null);
    const menuRef = useRef<HTMLDivElement>(null);
    const menuProgressRef = useRef<HTMLDivElement>(null);
    const items = [menuRef, menuProgressRef];
    const fadeIn = useTransform(scrollYProgress, [0.1, 0.2], [0, 1]);

    const closeMenu = () => {
        if (isActive) {
            toggle();
        }
    }

    useEffect(() => {
        axios.get(weatherAPI).then((res) => {
            setIcon(res.data.iconCode[0].toString().padStart(2, '0'));
            setWeatherConditions(res.data.wxPhraseLong[0]);
            setTemperature(res.data.temperature[0]);
        });
    }, []);

    const updateVisibility = (latest: number) => {
        if (latest > 0.1 || width < 950 || pathname !== '/') {
            items.forEach(e => e.current?.classList.remove('ignore-clicks'));
        }
        else {
            items.forEach(e => e.current?.classList.add('ignore-clicks'));
        }
    }

    useMotionValueEvent(scrollYProgress, "change", (latest) => {
        updateVisibility(latest);
    });

    const updateTime = () => {
        const currentTime = new Date();
        const timeStr = currentTime.toLocaleString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true, timeZone: 'America/Chicago' });
        setTime(timeStr);
    }

    useEffect(() => {
        const repeat = setInterval(updateTime, 1000);
        setTimeout(() => {
            if (nameRef.current !== null) {
                nameRef.current!.id = 'topleft-name';
            }
        }, 2400);
        setTimeout(() => updateVisibility(scrollYProgress.get()), 400);
        return () => clearInterval(repeat);
    });

    return (
        <nav>
            <RenderIf condition={pathname === '/'}>
                <h3 id="topleft-name-info">
                    <RenderIf condition={width <= 470}
                        fallback={<h3 ref={nameRef}><span style={{animationDelay: '1000ms'}}>Pranav // </span><span style={{animationDelay: '1100ms'}}>Pakanati</span></h3>}>
                        <h3 ref={nameRef}><span style={{animationDelay: '1000ms'}}>Pranav P.</span></h3>
                    </RenderIf>
                    <span id="topleft-location">Frisco, TX</span>
                    <span id="topleft-time">{time}</span>
                    <div id="topleft-weather">
                        <img src={`/weather-icons/${weatherIcon}.svg`} alt='' title={weatherConditions} />
                        {temperature === undefined ? '' : `${temperature} °F`}
                    </div>
                </h3>
            </RenderIf>
            <Spacer />
            <RenderIf condition={width >= 950} fallback={
                <>
                    <MobileDropdownMenu isVisible={isActive} closeMenuFunc={toggle} scrollYProgress={scrollYProgress} /> 
                    <div id="menu" ref={menuRef}>
                        <h3 onClick={toggle} className={isActive ? 'active' : undefined}>Menu</h3>
                        <div className={isActive ? "line active" : "line"} id="menu-line-1" onClick={toggle}></div>
                        <div className={isActive ? "line active" : "line"} id="menu-line-2" onClick={toggle}></div>
                    </div>
                </>
            }>
                <>
                    <motion.div style={{ opacity: pathname === '/' ? fadeIn : 1 }}>
                        <DropdownMenu isVisible={isActive} closeMenuFunc={closeMenu} scrollYProgress={scrollYProgress} menuProgressRef={menuProgressRef} />
                        <div id="menu" ref={menuRef}>
                            <h3 onClick={toggle} className={isActive ? 'active' : undefined}>Menu</h3>
                            <div className={isActive ? "line active" : "line"} id="menu-line-1" onClick={toggle}></div>
                            <div className={isActive ? "line active" : "line"} id="menu-line-2" onClick={toggle}></div>
                        </div>
                    </motion.div>
                    <RenderIf condition={pathname === '/'}>
                        <h3 id="section-links">
                            <span style={{animationDelay: '1200ms'}}>
                                <a href="/#about-me" className="hover-link" onClick={e => scrollToSection(e, 'about-me')}>
                                    About M<span className="last-letter">e</span>
                                </a>{' // '}
                            </span>
                            <span style={{animationDelay: '1300ms'}}>
                                <a href="#skills" className="hover-link" onClick={e => scrollToSection(e, 'skills')}>
                                    Skill<span className="last-letter">s</span>
                                </a>{' // '}
                            </span>
                            <span style={{animationDelay: '1400ms'}}>
                                <a href="#projects" className="hover-link" onClick={e => scrollToSection(e, 'projects')}>
                                    Project<span className="last-letter">s</span>
                                </a>{' // '}
                            </span>
                            <span style={{animationDelay: '1500ms'}}>
                                <a href="#contact" className="hover-link" onClick={e => scrollToSection(e, 'contact')}>
                                    Contac<span className="last-letter">t</span>
                                </a>
                            </span>
                        </h3>
                    </RenderIf>
                </>
            </RenderIf>
        </nav>
    )
}

export default Navbar;